import './scss/GlobalStyle.scss';

type Props = {
    children: JSX.Element;
};

const Home = ({ children }: Props): JSX.Element => {
    return children;
};

export default Home;
